import {
    ACTIVATING_EXTERNAL_SCRIPT_REQUEST, ACTIVATING_EXTERNAL_SCRIPT_SUCCEDDED, ACTIVATING_EXTERNAL_SCRIPT_FAILED,
    UPDATING_EXTERNAL_SCRIPT_REQUEST, UPDATING_EXTERNAL_SCRIPT_SUCCEDDED, UPDATING_EXTERNAL_SCRIPT_FAILED
  } from '../../actions/actionTypes.jsx';
  
  const initialState = {
    changes: {
      saving: false,
      error: null
    },
    activation: {
      activating: false,
      error: null
    },
    deactivation: {
      deactivating: false,
      error: null
    }
  };
  
  function externalScriptReducer(state = initialState, action) {
    switch (action.type) {
      case ACTIVATING_EXTERNAL_SCRIPT_REQUEST:
        return Object.assign({}, state, {
          ...state,
          activation: {
            activating: true,
            error: null
          }
        })
      case ACTIVATING_EXTERNAL_SCRIPT_SUCCEDDED:
        return Object.assign({}, state, {
          ...state,
          activation: {
            activating: false,
            error: null
          }
        })
      case ACTIVATING_EXTERNAL_SCRIPT_FAILED:
        return Object.assign({}, state, {
          ...state,
          activation: {
            activating: false,
            error: action.payload
          }
        })
  
      case UPDATING_EXTERNAL_SCRIPT_REQUEST:
        return Object.assign({}, state, {
          ...state,
          changes: {
            saving: true,
            error: null
          }
        })
      case UPDATING_EXTERNAL_SCRIPT_SUCCEDDED:
        return Object.assign({}, state, {
          ...state,
          changes: {
            saving: false,
            error: null
          }
        })
      case UPDATING_EXTERNAL_SCRIPT_FAILED:
        return Object.assign({}, state, {
          ...state,
          changes: {
            saving: false,
            error: action.payload
          }
        })
      default:
        return state
    }
  }
  
  export { externalScriptReducer };